import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			deviceType: 'pc',
			// deviceType: 'mobile',
			showDebug: false,
			ads: {},
			adPosConfig: {
				homeinsertCutPos: [
					//0为起始，1为需要左侧展示的图片数量。
					//除了0 后面的4，8 都是根据console算出来的，因为右侧图片会有几个缺失
					[0, 1],
					[4, 3],
					[14, 3],
				], //第二个后和第6个后插入fullsize广告
				home: [2], //从第6开始后的第2个（对应之前的8,11
				detail: [3, 5, 8, 11],

				homeTypes: [2],
				homeInsert: [2],
				homeInsertPC: [8],
				sortInsert: [1, 3],
				detailInsert: [1],
				detailInsertPC: [8],
			},

			adsensConfig: {},
			domainConfig: {},
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			setDietTypeList(state, list) {
				state.dietTypeList = list
			},
			setDietFetureList(state, list) {
				state.dietFetureList = list
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			dietTypeList: (state) => state.dietTypeList,
			dietFetureList: (state) => state.dietFetureList,
		},
	})
}
